"use strict";
angular.module("submissionLibraryServiceModule", [
    "lookMoreModule", //查看更多
]).
factory("submissionLibraryService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 新增/编辑角色
         * @param {[string]} [userId] [description]
         */
        lookMore: function(roleId,roleName) {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/submissionManage/submissionLibrary/service/lookMore/lookMore_tpl.html",
                windowClass: 'lookMore',
                backdrop: false,
                controller: "lookMoreCtrl",
                resolve: {
                    roleId: function(){
                    	return roleId;
                    },

                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);